import React from "react";
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import HeaderLogo from "components/Header/HeaderLogo.js";
import Footer from "components/Footer/Footer.js";
import HeaderTransparent from "components/Header/HeaderTransparent.js";
import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import { language } from 'config';

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function PrivacyPolicy(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <HeaderLogo
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderTransparent />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <h2 className={classes.title}>{language.privacy_policy}</h2>
            <p className={classes.description}>{language.privacy_policy_para1}</p>
            <h2 className={classes.title}>{language.collection_of_information}</h2>
            <p className={classes.description}>{language.privacy_policy_para2}</p>
            <h2 className={classes.title}>{language.information_collect}</h2>
            <p className={classes.description}>{language.privacy_policy_para3}</p>
            <p className={classes.description}>{language.privacy_policy_para4}</p>
            <p className={classes.description}>{language.privacy_policy_para5}</p>
            <p className={classes.description}>{language.privacy_policy_para6}</p>
            <p className={classes.description}>{language.privacy_policy_para7}</p>
            <p className={classes.description}>{language.privacy_policy_para8}</p>
            <p className={classes.description}>{language.privacy_policy_para9}</p>
            <p className={classes.description}>{language.privacy_policy_para10}</p>
            <p className={classes.description}>{language.privacy_policy_para11}</p>
            <h2 className={classes.title}>{language.policy_governance}</h2>
            <p className={classes.description}>{language.privacy_policy_para12}</p>
            <p className={classes.description}>{language.privacy_policy_para13}</p>
            <p className={classes.description}>{language.privacy_policy_para14}</p>
            <p className={classes.description}>{language.privacy_policy_para15}</p>
            <p className={classes.description}>{language.privacy_policy_para16}</p>
            <p className={classes.description}>{language.privacy_policy_para17}</p>
            <p className={classes.description}>{language.privacy_policy_para18}</p>
            <p className={classes.description}>{language.privacy_policy_para19}</p>
            <br/>
        </div>
        </div>

      <Footer />
    </div>
  );
}